if(jQuery('#contato-mapa').length) {
  
  let coordinates = typeof(map_coordinates) != 'undefined' ? map_coordinates : [ -50.8876429, -26.388268 ];
  
  let pin = [
    new ol.Feature({
      geometry: new ol.geom.Point(ol.proj.fromLonLat( coordinates )),
      name: 'Pin',
    })
  ];
  
  let map = new ol.Map({
    target: 'contato-mapa',
    interactions: ol.interaction.defaults({dragPan: true, mouseWheelZoom: false}).extend([
      new ol.interaction.DragPan({
        condition: function (event) {
          return this.getPointerCount() === 2 || ol.events.condition.platformModifierKeyOnly(event);
        },
      }),
      new ol.interaction.MouseWheelZoom({
        condition: ol.events.condition.platformModifierKeyOnly,
      }),
    ]),
    layers: [
      new ol.layer.Tile({
        title: 'Brixner',
        className: 'bw',
        source: new ol.source.OSM()
      }),
      new ol.layer.Vector({
        source: new ol.source.Vector({
          className: 'icon',
          features: pin
        }),
        style: new ol.style.Style({
          image: new ol.style.Icon({
            anchor: [0.5, 1],
            anchorXUnits: 'fraction',
            anchorYUnits: 'fraction',
            scale: 1,
            src: jQuery('#contato-mapa').data('markers')
          })
        })
      }),
    ],
    view: new ol.View({
      center: ol.proj.fromLonLat( coordinates ),
      zoom: 17
    })
  });
  
}